import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './UnderDevelopment.css';

const UnderDevelopment = ({ title, description }) => {
  return (
    <section className="section-padding">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <div className="under-development-content">
              <h1 className="section-title">{title}</h1>
              <div className="construction-icon">
                <i className="fas fa-hard-hat"></i>
              </div>
              <p className="description">{description}</p>
              <div className="coming-soon">Coming Soon</div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UnderDevelopment; 